import React from 'react';

function MdbChart() {
    return (
        <iframe style={{ width: '100%', height: '100%' }} src="https://charts.mongodb.com/charts-bulkpe-bqzix/embed/dashboards?id=b98fbb56-0f94-4710-8470-172393f81eee&theme=light&autoRefresh=true&maxDataAge=300&showTitleAndDesc=false&scalingWidth=fixed&scalingHeight=fixed"></iframe>
    );
}

export default MdbChart;